// extracted by mini-css-extract-plugin
export var centreLogo = "index-module--centreLogo--e6f8f";
export var col = "index-module--col--d3911";
export var logo = "index-module--logo--ef0f1";
export var mobileMenuToggle = "index-module--mobileMenuToggle--c7932";
export var wrapper = "index-module--wrapper--7d633";